import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./adminDashboard.css";

const API = "https://lismount-api.onrender.com/api";

function AdminDashboard() {

  const [products, setProducts] = useState([]);

  const [form, setForm] = useState({
    name: "",
    description: "",
    image: "",
    inStock: true
  });

  const [editId, setEditId] = useState(null);


  const fetchProducts = async () => {

    try {

      const res = await fetch(`${API}/products`);
      const data = await res.json();

      setProducts(data);

    } catch (error) {

      Swal.fire(
        "Error",
        "Failed to load products",
        "error"
      );

    }

  };


  useEffect(() => {
    fetchProducts();
  }, []);



  const handleSubmit = async () => {

    if (!form.name || !form.description) {

      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning"
      );

      return;
    }

    try {

      if (editId) {

        await fetch(`${API}/products/${editId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(form)
        });

        Swal.fire(
          "Updated!",
          "Product updated successfully",
          "success"
        );

      } else {

        await fetch(`${API}/products`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(form)
        });

        Swal.fire(
          "Added!",
          "Product added successfully",
          "success"
        );

      }

      setForm({
        name: "",
        description: "",
        image: "",
        inStock: true
      });

      setEditId(null);

      fetchProducts();

    } catch (error) {

      Swal.fire(
        "Error",
        "Something went wrong",
        "error"
      );

    }

  };


  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This product will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it"
    });

    if (!result.isConfirmed) return;

    try {

      await fetch(`${API}/products/${id}`, {
        method: "DELETE"
      });

      Swal.fire(
        "Deleted!",
        "Product deleted successfully",
        "success"
      );

      fetchProducts();

    } catch (error) {

      Swal.fire(
        "Error",
        "Delete failed",
        "error"
      );

    }

  };


  const handleEdit = (product) => {

    setForm({
      name: product.name,
      description: product.description,
      image: product.image,
      inStock: product.inStock
    });

    setEditId(product.id);

    window.scrollTo({ top: 0, behavior: "smooth" });

  };


  const handleImageUpload = (event) => {

    const file = event.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {

      setForm({
        ...form,
        image: reader.result
      });

    };

    reader.readAsDataURL(file);

  };


  return (

    <div className="admin-dashboard-wrapper">

      <div className="admin-container">

        <h2 className="admin-title">Admin Product Dashboard</h2>

        <div className="product-form">

          <h3>{editId ? "Edit Product" : "Add Product"}</h3>

          <input
            className="input-field"
            placeholder="Product Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />

          <input
            type="file"
            onChange={handleImageUpload}
          />

          {form.image && (
            <img
              src={form.image}
              alt="preview"
              className="preview-img"
            />
          )}

          <textarea
            className="input-field"
            placeholder="Description"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />

          <label className="stock-check">

            <input
              type="checkbox"
              checked={form.inStock}
              onChange={(e) => setForm({ ...form, inStock: e.target.checked })}
            />

            In Stock

          </label>

          <button
            className="submit-btn"
            onClick={handleSubmit}
          >
            {editId ? "Update Product" : "Add Product"}
          </button>

        </div>


        <h3 className="product-list-title">Products</h3>

        <div className="product-grid">

          {products.map((p) => (

            <div key={p.id} className="product-card">

              <img
                src={p.image}
                alt={p.name}
                className="product-image"
              />

              <h4>{p.name}</h4>

              <p className="stock-status">
                {p.inStock ? "In Stock" : "Out of Stock"}
              </p>

              <div className="card-buttons">

                <button
                  className="edit-btn"
                  onClick={() => handleEdit(p)}
                >
                  Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => handleDelete(p.id)}
                >
                  Delete
                </button>

              </div>

            </div>

          ))}

        </div>

      </div>

    </div>

  );

}

export default AdminDashboard;